import UploadIcon from '@icons/UploadIcon/UploadIcon.tsx';
import { formatFileSize } from '@utils/utils.ts';
import { FileTag } from '@components/UploadForm/ui/FileTag/FileTag.tsx';
import { useDropzone } from 'react-dropzone';
import { Dispatch, FC, SetStateAction } from 'react';
import {
  ALLOWED_FILE_EXTENSIONS,
  FILE_SIZE_LIMIT,
} from '@static/staticData.ts';
import toast from 'react-hot-toast';
import { Toast } from '@components/Toast/ui/Toast.tsx';
import styles from './DataBaseUploadForm.module.scss';

interface IDataBasesUploadFormProps {
  files: File[];
  setFiles: Dispatch<SetStateAction<File[]>>;
}

const DataBasesUploadForm: FC<IDataBasesUploadFormProps> = ({
  files,
  setFiles,
}) => {
  const throwError = (errorMessage: string) => {
    toast(({ id }) => (
      <Toast id={id} type="error" title="Error" text={errorMessage} />
    ));
  };
  const onDrop = (filesToUpload: File[]) => {
    const filteredFiles: File[] = filesToUpload.filter((file) => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      if (file.size > FILE_SIZE_LIMIT) {
        throwError(`${file.name} file too big`);
        return false;
      }

      if (!fileExtension) {
        throwError('Incorrect file type');
        return false;
      }

      if (!ALLOWED_FILE_EXTENSIONS.includes(fileExtension)) {
        throwError(
          `Only ${ALLOWED_FILE_EXTENSIONS.join(', ')} files are allowed.`
        );
        return false;
      }

      return true;
    });

    setFiles((prevState) => [...prevState, ...filteredFiles]);
  };

  const onFileRemove = (filename: string) => {
    setFiles((prevState) => prevState.filter((file) => file.name != filename));
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div className={styles.uploadWrapper}>
      <div className={styles.uploadForm} {...getRootProps()}>
        <div className={styles.icon}>
          <div className={styles.inner}>
            <UploadIcon />
          </div>
        </div>
        <input {...getInputProps()} />
        <div className={styles.text}>
          <p>
            <span>Click to upload</span> or drag and drop
            <br />
            {formatFileSize(FILE_SIZE_LIMIT)})
          </p>
        </div>
      </div>
      <div className={styles.files}>
        {files?.map((file, index) => (
          <FileTag key={index} file={file} removeFile={onFileRemove} />
        ))}
      </div>
    </div>
  );
};

export default DataBasesUploadForm;
